import Vue from 'vue';
import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';

export const filters = {
    uppercase: (value: string) => {
        if (!value) {
            return '';
        }

        value = value.toString();
        return value.toUpperCase();
    },
    numFormat: numFormat(numeral),
    capitalize: (value: string) => {
        if (!value) {
            return '';
        }

        value = value.toString();
        return value.charAt(0).toUpperCase() + value.slice(1);
    },
    bytesFormat: (bytes: any, decimals: any, kib: any, maxunit: any) => {
        kib = kib || false;

        if (bytes === 0) {
            return '0 Bytes';
        }

        if (isNaN(parseFloat(bytes)) && !isFinite(bytes)) {
            return 'Not an number';
        }

        const k = kib ? 1024 : 1000;
        const dm = decimals !== null && !isNaN(decimals) && decimals >= 0 ? decimals : 2;
        const sizes = kib ? ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB', 'BiB'] : ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB', 'BB'];
        let i = Math.floor(Math.log(bytes) / Math.log(k));

        if (maxunit !== undefined) {
            const index = sizes.indexOf(maxunit);

            if (index !== -1) {
                i = index;
            }
        }

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    stringToBytes(fileSize: string) {
        const parseRegExp = /^((-|\+)?(\d+(?:\.\d+)?)) *(Bytes|KB|MB|GB|TB|PB)$/i;

        /* tslint:disable:no-bitwise */
        const map: any = {
            Bytes:  1,
            KB: 1 << 10,
            MB: 1 << 20,
            GB: 1 << 30,
            TB: Math.pow(1024, 4),
            PB: Math.pow(1024, 5),
        };
        /* tslint:enable:no-bitwise */

        const results = parseRegExp.exec(fileSize);

        let floatValue;
        let unit = 'Bytes';

        if (!results) {
            floatValue = parseInt(fileSize, 10);
            unit = 'Bytes';
        } else {
            floatValue = parseFloat(results[1]);
            unit = results[4];
        }

        return Math.floor(map[unit] * floatValue);
    },
    truncate: (text: string | null, length: number | null, clamp: string | null) => {
        clamp = clamp || '...';
        length = length || 30;

        if (text === null || text.length <= length) {
            return text;
        }

        let tcText = text.slice(0, length - clamp.length);
        let last = tcText.length - 1;

        while (last > 0 && tcText[last] !== ' ' && tcText[last] !== clamp[0]) {
            last -= 1;
        }

        last = last || length - clamp.length;

        tcText =  tcText.slice(0, last);

        return tcText + clamp;
    },
    nl2br: (text: string) => {
        if (text.trim() !== '') {
            return text.replace(/(?:\r\n|\r|\n)/gm, '<br>');
        }

        return text;
    },
};

export default filters;
